import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Entry from './Entry';

const Banner = ({className, entries, Entry, ...props}) => (
    entries.length > 0 && (
        <div className={classNames('row', 'messages', className)}>
            <div className="col s12">
                {entries.map(entry => <Entry {...entry} {...props} />)}
            </div>
        </div>
    )
);

Banner.propTypes = {
    className: PropTypes.string,
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
        }),
    ).isRequired,
    Entry: PropTypes.func,
};

Banner.defaultProps = {
    className: null,
    Entry,
};

export default Banner;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/Banner/Banner.js